// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__29LiN","content":"Consent_content__qfdSc","footer":"Consent_footer__1XF3g"};